import SettingsLayout from "@pages/SettingsPage/SettingsLayout";
import PersonalDetails from "@pages/SettingsPage/components/PersonalDetails";
import Username from "@pages/SettingsPage/components/Username";
import ChangePassword from "@pages/SettingsPage/components/ChangePassword";
import JobApplicationDetail from "@pages/Ambassador/Network/JobApplicationDetail/JobApplicationDetail";
import MyAccountSettingsPage from "@pages/MyAccountSettingsPage/MyAccountSettingsPage";

import { Navigate, RouteObject } from "react-router-dom";
import { routerLoaders } from "router";
import TrackerPage from "@pages/ActivityTracker/TrackerPage";
import DashboardPage from "@pages/Dashboard/Dashboard";
import NetworkLayout from "@pages/Ambassador/Network/NetworkLayout";
import MyNetwork from "@pages/Ambassador/Network/MyNetwork/MyNetwork";
import NetworkDetailLayout from "@pages/Ambassador/Network/NetworkDetail/NetworkDetailLayout";
import PaymentLayout from "@pages/referralAmbassador/Payment/PaymentLayout";
import PaymentReceived from "@pages/referralAmbassador/Payment/sections/PaymentReceived";
import ManageBankAccount from "@pages/referralAmbassador/Payment/sections/ManageBankAccount";
import HomePage from "@pages/HomePage/HomePage";
import Invitations from "@pages/Ambassador/Network/Invitations/Invitations";
import Profile from "@pages/referralAmbassador/Profile/Profile";
import MyRecruiterNetwork from "@pages/Ambassador/Network/MyRecruiterNetwork/MyRecruiterNetwork";
import WithdrawalHistory from "@pages/referralAmbassador/Payment/sections/WithdrawalHistory";
import EarningBreakdown from "@pages/referralAmbassador/Payment/sections/EarningBreakdown";
import MatchesDetailsPage from "@pages/MatchesPage/MatchesDetailsPage";
import MatchesPage from "@pages/MatchesPage/MatchesPage";

const { authLoader } = routerLoaders();

export const ReferralAmbassadorRoutes: RouteObject[] = [
  {
    path: "/home",
    loader: authLoader,
    element: <HomePage />,
  },
  {
    path: "/dashboard",
    loader: authLoader,
    element: <DashboardPage />,
  },
  {
    path: "/tracker",
    loader: authLoader,
    element: <TrackerPage />,
  },
  {
    path: "/payment",
    loader: authLoader,
    // element:<div/>
    element: <PaymentLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={"payment-received"} />,
      },
      {
        path: "payment-received",
        element: <PaymentReceived />,
      },
      {
        path: "manage-bank-accounts",
        element: <ManageBankAccount />,
      },
      {
        path: "withdrawal-history",
        element: <WithdrawalHistory />,
      },
      {
        path: "earning-breakdown",
        element: <EarningBreakdown />,
      },
    ],
  },
  // {
  //   path: "/network",
  //   loader: authLoader,
  //   children: [
  //     {
  //       index: true,
  //       element: <NetworkPage />,
  //     },
  //     {
  //       path: ":candidateId",
  //       loader: authLoader,
  //       element: <NetworkDetailPage />,
  //     },
  //     {
  //       path: ":candidateId/:jobId",
  //       element: <JobApplicationDetail />,
  //     },
  //   ],
  // },
  {
    path: "/matches",
    loader: authLoader,
    children: [
      {
        index: true,
        element: <MatchesPage />,
      },
      {
        path: ":candidateId/:jobId",
        loader: authLoader,
        element: <MatchesDetailsPage />,
      },
    ],
  },
  {
    path: "/matched-job-details/:candidateId",
    loader: authLoader,
    element: <JobApplicationDetail />,
  },
  {
    path: "/network",
    loader: authLoader,
    element: <NetworkLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={"my-network"} />,
      },
      {
        path: "my-network",
        element: <MyNetwork />,
      },
      {
        path: "my-recruiter-network",
        element: <MyRecruiterNetwork />,
      },
      {
        path: "invitations",
        loader: authLoader,
        element: <Invitations />,
      },
    ],
  },
  {
    path: "/network/:candidateId",
    loader: authLoader,
    element: <NetworkDetailLayout />,
    // children: [
    //   {
    //     index: true,
    //     element: <CandidateDetails />,
    //   },
    //   {
    //     path: "details",
    //     element: <CandidateDetails />,
    //   },
    //   {
    //     path: "matched-jobs",
    //     element: <MatchedJobs />,
    //   },
    // ],
  },
  // {
  //   path: "/network/:candidateId",
  //   loader: authLoader,
  //   element: <NetworkDetailPage />,
  // },
  {
    path: "/network/:candidateId/:jobId",
    element: <JobApplicationDetail />,
  },
  {
    path: "/account",
    loader: authLoader,
    element: <MyAccountSettingsPage />,
  },
  {
    path: "/profile",
    loader: authLoader,
    element: <Profile />,
  },
  {
    path: "/settings",
    loader: authLoader,
    element: <SettingsLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={"account"} />,
      },
      {
        path: "account",
        children: [
          {
            index: true,
            element: <Navigate to={"personal-details"} />,
          },
          {
            path: "personal-details",
            element: <PersonalDetails />,
          },
          {
            path: "username",
            element: <Username />,
          },
          {
            path: "change-password",
            element: <ChangePassword />,
          },
        ],
      },
    ],
  },
];
